@let event = eventStoreService.event();
@let sessions = event?.sessions || [];
@let shoutouts = shoutoutsStoreService.shoutouts() || [];

<div class="button-container">
  @if (sessions && sessions.length > 0) {
    <mat-form-field class="shoutouts-filters__input" appearance="outline">
      <mat-label for="sessionId">All sessions</mat-label>
      <mat-select (selectionChange)="sessionId.set($event.value)">
        <mat-option [value]="null">All sessions</mat-option>
        @for (session of sessions; track session.id) {
          <mat-option [value]="session.id">{{ session.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <button
    mat-flat-button
    color="primary"
    aria-label="Start in Fullscreen"
    class="show_fullscreen"
    (click)="showFullscreen()"
  >
    Start in Fullscreen
  </button>
</div>

<div class="background" #shoutoutWall>
  @for (shoutout of shoutouts; track shoutout; let i = $index) {
    <div class="fade-in shoutout">
      @if (i == rotationIndex()) {
        <div class="to">
          <span class="to-athlete">{{ shoutout.to }}</span>
          @if (shoutout.team !== "") {
            <span> from {{ shoutout.team }}</span>
          }
        </div>
        <div class="message">
          <span class="quote quote--left">&ldquo;</span>{{ shoutout.message
          }}<span class="quote quote--right">&rdquo;</span>
        </div>
        <div class="from">{{ shoutout.from }}</div>
      }
    </div>
  }
  @if (rotationIndex() == shoutouts?.length) {
    <div class="qr-code">
      <qrcode
        [qrdata]="shareLink()"
        [width]="qrWidth()"
        [errorCorrectionLevel]="'M'"
      >
      </qrcode>
    </div>
  }
  <img src="/assets/logo-sm.png" class="logo" alt="logo" />
  <a
    href="https://ultimateshoutouts.com"
    class="branding"
    target="_blank"
    rel="noopener noreferrer"
  >
    ultimateshoutouts.com
  </a>
</div>
